import { ReactNode } from 'react'
import { useBillingSync } from '@/hooks/useBillingSync'

interface BillingSyncProviderProps {
  children: ReactNode
}

/**
 * Component that automatically syncs billing on user login
 * Wraps the app to ensure billing is synced whenever a user is authenticated
 */
export function BillingSyncProvider({ children }: BillingSyncProviderProps) {
  // This hook automatically syncs on mount when user is logged in
  useBillingSync()
  
  return <>{children}</>
}
